import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { z } from 'zod';
import { api } from '../../services/api';

const schema = z.object({
  email: z.string().email(),
});

type ForgotForm = z.infer<typeof schema>;

export default function ForgotPasswordPage(): React.ReactElement {
  const { t } = useTranslation('auth');
  const [sent, setSent] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ForgotForm>({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data: ForgotForm): Promise<void> => {
    await api.post('/v1/auth/forgot-password', data);
    setSent(true);
  };

  return (
    <div className="min-h-screen flex items-start justify-center pt-20 px-4">
      <div className="card bg-base-100 shadow-xl w-full max-w-md">
        <div className="card-body">
          <h2 className="card-title text-3xl font-bold justify-center mb-4">
            {t('forgotPassword.title')}
          </h2>

          {sent && (
            <div className="alert alert-success mb-4">
              <span>{t('forgotPassword.success')}</span>
            </div>
          )}

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className="form-control w-full mb-3">
              <label className="label">
                <span className="label-text">{t('forgotPassword.email')}</span>
              </label>
              <input
                type="email"
                className={`input input-bordered w-full ${errors.email ? 'input-error' : ''}`}
                {...register('email')}
              />
              {errors.email && (
                <label className="label">
                  <span className="label-text-alt text-error">{errors.email.message}</span>
                </label>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-primary w-full mt-2 mb-2"
              disabled={isSubmitting || sent}
            >
              {t('forgotPassword.submit')}
            </button>
          </form>

          <div className="text-center mt-2">
            <RouterLink to="/login" className="link link-primary text-sm">
              {t('forgotPassword.backToLogin')}
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  );
}
